// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"bea_a bht_ea bht_ke bht_ju bht_sn bht_wl"};